<template>
	<v-container class="mt-4 ml-2 pr-6" fluid fill="height">
	  <v-row justify="center" align="center">
	  	<v-col cols="12" md="6" lg="4">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <v-spacer></v-spacer>
	  		  	<v-img src="@/assets/logo.png" max-width="150"></v-img>
	  		    <v-spacer></v-spacer>
	  		    <!-- <span class="text-subtitle-1">usuarios</span>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn> -->
	  		  </v-card-title>

	  		  <v-card-text v-if="pago" class="text-center black--text">
	  		  	<div><b>Nombre</b></div>
	  		  	<div>{{ pago.customer.name }}</div><br/>
	  		  	
	  		  	<div><b>Folio</b></div>
	  		  	<div>{{ pago.order_id }}</div><br/>
	  		  	
	  		  	<div><b>Estatus</b></div>
	  		  	<div>{{ pago.status }}</div><br/>
	  		  	
	  		  	<div><b>Fecha de pago</b></div>
	  		  	<div>{{ pago.creation_date }}</div><br/>
	  		  	
	  		  	<div><b>Motivo</b></div>
	  		  	<div>{{ pago.description }} </div><br/>
	  		  	
	  		  	<div><b>Pago</b></div>
	  		  	<div>{{ format( pago.amount ) }}</div><br/>


	  		  	<div v-if="pago.error_message"><b>Error</b></div>
	  		  	<div v-if="pago.error_message">{{ pago.error_message }}</div><br/>

	  		  </v-card-text>
	  		  <v-card-actions v-if="pago && ( pago.error_message || pago.status != 'completed') ">
	  		  	<v-btn color="primary" tile block @click="openView()"> Reintentar pagar</v-btn>
	  		  </v-card-actions>
	  		</v-card>
	  	</v-col>
	  </v-row>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'


  export default {

    mixins: [ validarErrores, funcionesExcel ],

    components:{
      Alerta,
      carga,
    },

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      idopenpay: 0,

      pago: null,
    }),

    computed: {
    	...mapGetters('login',['getdatosUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar categoria' : 'Editar categoria'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

    },

    async created () {

    	console.log('vista creada')

    	const url = window.location.href;

    	console.log('url vista', url)


			// Buscar el índice del carácter '?' en la URL
			const index = url.indexOf('?');

			// Verificar si existe el parámetro 'id' en la URL
			if (index !== -1) {
			    // Obtener la parte de la URL que contiene los parámetros
			    const paramsString = url.substring(index + 1);

			    // Convertir la cadena de parámetros en un objeto
			    const params = new URLSearchParams(paramsString);

			    // Obtener el valor del parámetro 'id'
			    const id = params.get('id');

			    // Verificar si se encontró el parámetro 'id' en la URL
			    if (id) {
			        console.log("ID recuperado:", id);
			        this.idopenpay = id
      				await this.initialize()
			        // Puedes usar 'id' como necesites en tu código
			    } else {
			        console.log("No se encontró el parámetro 'id' en la URL.");
			    }
			} else {
			    console.log("No se encontraron parámetros en la URL.");
			}

    },

    methods: {
      initialize () {
      	this.cargar = true
        this.usuarios = []

        const payload = {
        	transactionId: this.idopenpay
        }

        return this.$http.post('pagos.ver', payload ).then(response=>{
        	this.pago = response.body
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      save () {
      	// Cargamos al usuario que hizo el cambio
	      this.cargar = true
        // Lo mandapos por el EP
        this.$http.put('usuarios.update/' + this.editedItem.idusuarios, this.editedItem).then(response=>{
        	this.validarSuccess( response.body.message )
        	this.initialize()
      		this.close()
        }).catch( error =>{
        	this.validarError( error )
      	}).finally( () => { this.cargar = false })
      },

      openView( ){
      	window.open( this.pago.payment_method.url )
      },

      format( valor ){
			  return valor.toLocaleString('es-MX', {
			    style: 'currency',
			    currency: 'MXN'
			  });
			}
    },
  }
</script>


